export default "__VITE_ASSET__CAwwEHtv__"